import { Route } from '@angular/router';
import { RoutePath } from '@univacity/shared/types';

export const authRoutes: Route[] = [
  {
    path: RoutePath.register,
    loadComponent: () =>
      import('./registration-page/registration-page.component').then(
        (m) => m.RegistrationPageComponent
      ),
  },
  {
    path: RoutePath.registerOrganisation,
    loadComponent: () =>
      import(
        './organisation-registration-page/organisation-registration-page.component'
      ).then((m) => m.OrganisationRegistrationPageComponent),
  },
  {
    path: RoutePath.login,
    loadComponent: () =>
      import('./login-page/login-page.component').then(
        (m) => m.LoginPageComponent
      ),
  },
  {
    path: RoutePath.forgotPassword,
    loadComponent: () =>
      import('./forgot-password-page/forgot-password-page.component').then(
        (m) => m.ForgotPasswordPageComponent
      ),
  },
  {
    path: RoutePath.resetPassword,
    loadComponent: () =>
      import('./reset-password-page/reset-password-page.component').then(
        (m) => m.ResetPasswordPageComponent
      ),
  },
  {
    path: RoutePath.emailVerification,
    loadComponent: () =>
      import('./verify-email-page/verify-email-page.component').then(
        (m) => m.VerifyEmailPageComponent
      ),
  },
];
